"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventFactory = void 0;
const eventFactory = (type) => (payload, meta) => ({
    type,
    payload,
    meta,
});
exports.eventFactory = eventFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZmFjdG9yeS9ldmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFTyxNQUFNLFlBQVksR0FBRyxDQUFJLElBQVksRUFBRSxFQUFFLENBQUMsQ0FDL0MsT0FBVSxFQUNWLElBQVUsRUFDQSxFQUFFLENBQUMsQ0FBQztJQUNkLElBQUk7SUFDSixPQUFPO0lBQ1AsSUFBSTtDQUNMLENBQUMsQ0FBQTtBQVBXLFFBQUEsWUFBWSxnQkFPdkIifQ==